import $ from 'jquery';
import Dropzone from 'dropzone';
import slugify from 'slugify';
import { handleSidebarImages } from '~src/sidebar/index';
import { getAxiosClient } from './api';
import { showSidebarTab, hideSidebarTab } from '~src/sidebarLegacy';
import { isLoggedUserGlobalEditor } from '~src/user';
import { modifyState } from '~src/state';

Dropzone.autoDiscover = false;

const uploadImages = async (base64String, filename, width, height, tags) => {
  $('#tab-imges-tag-upload #editor-btn-spinner').show();
  const httpClient = await getAxiosClient();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const data = {
    toFile_file: {
      b64: base64String,
      name: slugify(filename),
    },
    width: width,
    height: height,
    relations: [
      {
        column: 'tags',
        class: 'editor_images_tags',
        toIds: tags,
      },
    ],
  };

  let tableName;

  if (isGlobalEditor) {
    tableName = 'editor_images_default';
    data.isGlobal = true;
  } else {
    tableName = 'editor_images';
  }

  return httpClient.post(`${process.env.PARSE_API_URL}/${tableName}`, {
    data,
  });
};

function createDropzoneImages() {
  const previewTemplate = `<div
  class="items-tag-image-container">
    <img
        src="../assets/svg/img-loader.gif"
        class="lazy items-tag-image"
    />
  </div>`;

  const dropzoneImages = new Dropzone('#sidebar-box-images', {
    maxFiles: 20,
    autoProcessQueue: false,
    url: '/',
    timeout: 0,
    previewTemplate: previewTemplate,
    acceptedFiles: 'image/jpeg,image/jpg,image/png,image/gif,image/svg+xml',
    previewsContainer: '#editor-sidebar-images', // Define the container to display the previews
    clickable: '#editor-sidebar-img-upload-btn', // Define the element that should be used as click trigger to select files.
  });

  dropzoneImages.on('addedfile', (file) => {
    setTimeout(() => {
      if (typeof file.accepted !== 'undefined' && file.accepted === false) {
        console.error('File not accepted', file.accepted);
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        const base64String = event.target.result;
        const fileName = slugify(file.name, {
          strict: true, // strip special characters except replacement, defaults to `false`
        });
        const selectedTags = $('#tagImageSelectUpload').val();

        try {
          await uploadImages(
            base64String,
            fileName,
            file.width,
            file.height,
            selectedTags
          );
          await handleSidebarImages(true);
          hideSidebarTab('imges-tag-upload');
          showSidebarTab('immagini');
        } catch (error) {
          console.error(error);
        }
      };
      reader.readAsDataURL(file);
    }, 100);
  });

  modifyState('dropzoneImages', dropzoneImages);
}

export { uploadImages, createDropzoneImages };
